import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const GoogleIcon24 = (props: SvgIconProps): React.ReactNode => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.68 12.1818C19.68 11.6146 19.6291 11.0691 19.5345 10.5455H12V13.64H16.3055C16.12 14.64 15.5564 15.4873 14.7091 16.0546V18.0618H17.2945C18.8073 16.6691 19.68 14.6182 19.68 12.1818Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20C14.16 20 15.9709 19.2836 17.2946 18.0618L14.7091 16.0545C13.9927 16.5345 13.0764 16.8182 12 16.8182C9.91637 16.8182 8.15273 15.4109 7.52364 13.52H4.85091V15.5927C6.16728 18.2073 8.87273 20 12 20Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52364 13.52C7.36364 13.04 7.27273 12.5273 7.27273 12C7.27273 11.4727 7.36364 10.96 7.52364 10.48V8.40729H4.85091C4.30909 9.48729 4 10.7091 4 12C4 13.2909 4.30909 14.5127 4.85091 15.5927L7.52364 13.52Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.18182C13.1746 7.18182 14.2291 7.58545 15.0582 8.37818L17.3527 6.08364C15.9673 4.79273 14.1564 4 12 4C8.87273 4 6.16728 5.79273 4.85091 8.40727L7.52364 10.48C8.15273 8.58909 9.91637 7.18182 12 7.18182Z"
        fill="#EA4335"
      />
    </SvgIcon>
  )
}
